import { render, staticRenderFns } from "./StaticFooter.vue?vue&type=template&id=3999a946&scoped=true&"
import script from "./StaticFooter.vue?vue&type=script&lang=js&"
export * from "./StaticFooter.vue?vue&type=script&lang=js&"
import style0 from "./StaticFooter.vue?vue&type=style&index=0&id=3999a946&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3999a946",
  null
  
)

export default component.exports